import { render, staticRenderFns } from "./ConfusionMatrixInModal.vue?vue&type=template&id=4d662702&scoped=true"
import script from "./ConfusionMatrixInModal.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d662702",
  null
  
)

export default component.exports